const actionKeyAliases: Record<string, string> = {
  '슬롯 생성': 'create_slot',
  'create_slot': 'create_slot',
  '슬롯 수정': 'update_slot',
  'update_slot': 'update_slot',
  '슬롯 삭제': 'delete_slot',
  'delete_slot': 'delete_slot',
  'slot_auto_deleted': 'delete_slot',
  '슬롯 환불': 'refund_slot',
  'refund_slot': 'refund_slot',
  '슬롯 연장': 'extend_slot',
  'extend_slot': 'extend_slot',
};

export const extractMainKey = (full: string): string => {
  if (!full) return '';
  const prefix = full.split(':')[0].trim();
  return actionKeyAliases[prefix] ?? '';
};

/**
 * 각 키별 태그 색상 · 라벨
 * (필요 시 여기서 색상/레이블만 수정하면 전체 반영)
 */
export const actionMeta: Record<string, { label: string; color: string }> = {
  create_slot: { label: '슬롯 생성', color: 'green' },
  update_slot: { label: '슬롯 수정', color: 'blue' },
  delete_slot: { label: '슬롯 삭제', color: 'red' },
  refund_slot: { label: '슬롯 환불', color: 'red' },
  extend_slot: { label: '슬롯 연장', color: 'purple' },
};


export const allowedActionKeys = new Set([
  'create_slot',
  'update_slot',
  'delete_slot',
  'refund_slot',
  'extend_slot',
]);
